import { AnswerNps } from 'domain/usecases/tracksale/answer-nps'
import { TracksaleRepository } from 'repository/interfaces/tracksale-repository'

export class RemoteAnswerNps implements AnswerNps {
  private readonly tracksaleRepository: TracksaleRepository

  constructor(tracksaleRepository: TracksaleRepository) {
    this.tracksaleRepository = tracksaleRepository
  }

  post(params: AnswerNps.Params): Promise<AnswerNps.Model> {
    return this.tracksaleRepository.answerNps(params)
  }
}

export type SearchDoctorsModel = AnswerNps.Model
